






































import { Vue, Component } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import LearningRequestFormCreateV2 from "@/components/learning-request-v2/LearningRequestFormCreateV2.vue";
import { learningRequestApi } from "@/getinfo-api";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import {
  StatusProfile as IStatusProfile,
  StatusProfileEdit as IStatusProfileEdit
} from "@/api-v2/learning-requests/models";
import CField from "@/components/form/CField.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { getCurrentCompanyId } from "@/plugins/roles";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import TextField from "@/components/form/CustomPage/textField.vue";
import ProfileStatusForm from "@/components/learning-request-v2/ProfileStatusForm.vue";
import ProfileStatusItem from "@/components/learning-request-v2/ProfileStatusItem.vue";
import draggable from "vuedraggable";
import EditorWithFile from "@/components/EditorWithFile.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";

@Component({
  components: {
    EditorWithFile,
    ProfileStatusItem,
    ProfileStatusForm,
    TextField,
    CBlock,
    CustomButton,
    CField,
    CPageButtons,
    LearningRequestFormCreateV2,
    CPage,
    draggable
  }
})
export default class Profile extends Vue {
  profile!: IStatusProfile;
  form!: IStatusProfileEdit;
  isLoading: boolean = false;
  data() {
    return {
      profile: undefined,
      form: undefined
    };
  }

  get selectedCompanyId() {
    return getCurrentCompanyId();
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "profiles" },
        label: `${this.$tc(this.$translate.LearningRequestProfile)}`
      },
      {
        label: this.profile.title,
        to: { name: "profile", params: { id: this.$route.params.id } }
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  async getProfile() {
    await learningRequestApi.StatusProfiles.getProfile(
      this.$route.params.id
    ).then(res => {
      this.profile = res.data;
      this.form = this.profile;
    });
  }

  accept() {
    learningRequestApi.StatusProfiles.editProfile(
      this.$route.params.id,
      this.form
    ).then(() => {
      this.$router.push({
        name: "profile",
        params: { id: this.$route.params.id }
      });
    });
  }

  remove() {
    learningRequestApi.StatusProfiles.deleteProfile(this.$route.params.id)
      .then(() => {
        this.$router.push({
          name: "profiles"
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  decline() {
    this.$router.push({
      name: "profile",
      params: { id: this.$route.params.id }
    });
  }

  created() {
    this.getProfile();
  }
}
